import { Stack, Typography } from "@mui/material";
import { OrganisationAvatar } from "components/layout/avatar/OrganisationAvatar";
import { Sx } from "utils/sx";
import { EventCard } from "./eventCard/EventCard";
import { EventCardMainSection } from "./eventCard/EventCardMainSection";
import { RecentOrganisation } from "./useRecentOrganisations";
import { Link } from "react-router-dom";
import { trackClick, trackingCategory } from "utils/tracking";

const organisationNameStyle: Sx = {
    overflow: "hidden",
    textOverflow: "ellipsis",
    display: "-webkit-box",
    WebkitLineClamp: "3",
    WebkitBoxOrient: "vertical",
};

export const RecentOrganisationCard: React.FC<{organisation: RecentOrganisation, sx?: Sx}> = ({ organisation, sx }) => {
    return <Link to={organisation.shortName} aria-label={organisation.name} onClick={trackClick("Organisation card", trackingCategory.recentOrganisationsCarousel)}>
        <EventCard sx={sx}>
            <EventCardMainSection>
                <Stack direction="row" spacing={1.5} alignItems="center" sx={(theme) => ({ maxHeight: theme.spacing(8) })}>
                    <OrganisationAvatar
                               alt={organisation.name}
                               src={organisation.logo}
                               size="xxl"
                    />
                    <Typography variant="h7" color="text.primary" sx={organisationNameStyle}>
                        {organisation.name}
                    </Typography>
                </Stack>
            </EventCardMainSection>
        </EventCard>
    </Link>;
};
